<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <span class="kbDarkBlueText--text d-block text-h6 mb-1">
        {{ $t('general.prepareEmail') }}
      </span>
    </v-col>
    <v-col cols="12">
      <v-stepper class="kbWhite" v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1"
                          step="1"
                          color="mainButtons">
            {{ $t('general.subject') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2"
                          step="2"
                          color="mainButtons">
            {{ $t('general.templates') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3"
                          step="3"
                          color="mainButtons">
            {{ $t('general.insertHtmlTemplate') }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row>
              <v-col cols="12">
                <EmailSubject :subject="email.subject"
                              @onStepChange="updateStep($event)"
                              @onSubjectChange="onSubjectChange($event)" />
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row>
              <v-col cols="12">
                <EmailTemplatesPicker :templateId="email.templateId"
                                      @onStepChange="updateStep($event)"
                                      @onSelectedTemplateChange="onSelectedTemplateChange"/>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-row>
              <v-col cols="12">
                <EmailTemplateCreator :was-template-saved-or-updated="wasTemplateSavedOrUpdated"
                                      @onHtmlExported="onHtmlExported($event)"
                                      @onSaveOrUpdateTemplateStatusChange="onSaveOrUpdateTemplateStatusChange()"
                                      @onStepChange="updateStep($event)"
                                      @setTemplateIdAfterSavingTemplate="onSelectedTemplateChange($event)" />
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
  </v-row>
</template>
<script>
import EmailSubject from '@/components/widgets/EmailTemplates/EmailSubject'
import EmailTemplatesPicker from '@/components/widgets/EmailTemplates/EmailTemplatesPicker'
import EmailTemplateCreator from '@/components/widgets/EmailTemplates/EmailTemplateCreator'
export default {
  components: { EmailTemplateCreator, EmailSubject, EmailTemplatesPicker },
  data () {
    return {
      step: 1
    }
  },
  methods: {
    onHtmlExported (html) {
      this.$emit('onHtmlExported', html)
    },
    onSaveOrUpdateTemplateStatusChange () {
      this.$emit('onSaveOrUpdateTemplateStatusChange')
    },
    onSelectedTemplateChange (templateId) {
      this.$emit('onSelectedTemplateChange', templateId)
    },
    onSubjectChange (subject) {
      this.$emit('onSubjectChange', subject)
    },
    updateStep (step) {
      this.step = step
    }
  },
  props: {
    email: {
      type: Object,
      required: true
    },
    wasTemplateSavedOrUpdated: {
      type: Boolean,
      default: false
    }
  }
}
</script>
